import { render, staticRenderFns } from "./pix-sidebar.vue?vue&type=template&id=3f8eb566&scoped=true"
import script from "./pix-sidebar.vue?vue&type=script&lang=js"
export * from "./pix-sidebar.vue?vue&type=script&lang=js"
import style0 from "./pix-sidebar.vue?vue&type=style&index=0&id=3f8eb566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8eb566",
  null
  
)

export default component.exports